import type { StoreStockCard } from 'models/api';
import type { OpeningHours } from 'models/openingHours';
import type { StoreId } from 'types';

interface Store {
	city: string;
	id: StoreId;
	latitude: string | number;
	longitude: string | number;
	name: string;
	postalCode?: string;
	regularOpeningHours?: OpeningHours[];
	specialOpeningHours?: OpeningHours[];
	storeArea?: string;
	streetAddress?: string;
	todaysOpeningHours?: OpeningHours;
	url?: string;
}

export function mapStoreMarker({
	isSelected,
	onSelectClick,
	store,
}: {
	isSelected: boolean;
	onSelectClick: () => void;
	store: Store;
}) {
	return {
		id: store.id,
		name: store.name,
		openHours: store.todaysOpeningHours?.description || '',
		isOpen: store?.todaysOpeningHours?.state?.toUpperCase() === 'OPEN',
		address: `${store.streetAddress}, ${store.postalCode}, ${store.city}`,
		storeArea: store.storeArea || '',
		url: store.url,
		latitude: Number(store.latitude),
		longitude: Number(store.longitude),
		isSelected,
		onSelectClick,
	};
}

export function mapStockStoreMarker({
	isSelected,
	onSelectClick,
	store,
}: {
	isSelected: boolean;
	onSelectClick: () => void;
	store: StoreStockCard;
}) {
	return {
		id: store.storeId,
		name: store.storeName,
		stockStatusText: store.stock?.text.generic,
		inStock: store.stock?.inStock,
		address: `${store.streetAddress}, ${store.postalCode}, ${store.city}`,
		storeArea: store.storeArea || '',
		url: store.storeUrl,
		latitude: Number(store.latitude),
		longitude: Number(store.longitude),
		isSelected,
		onSelectClick,
	};
}
